/**
 * @module cercaliagl/layer/Manager
 */
import BaseLayer, { LayersId } from './Base';
import { BaseLayerType } from '../MapStyler';
var Manager = /** @class */ (function () {
    /**
     * @constructor
     * @param {import("../Map").default} map Cercalia map object
     * @param {import("../MapStyler").default} mapStyler Map styler object
     */
    function Manager(map, mapStyler) {
        /**
         * @private
         * @param {import("../Map").default}
         */
        this.cercaliaMap_ = map;
        /**
         * @private
         * @param {import("../MapStyler").default}
         */
        this.mapStyler_ = mapStyler;
        /**
         * @private
         * @param {boolean}
         */
        this.buildings3dEnabled_ = false;
        /**
         * @private
         * @param {Array.<import("./Base").LayerLike>}
         */
        this.layers_ = [];
    }
    /**
     * Get Layer
     * @param {string} id Id
     * @return {import("./Base").LayerLike|null} Layer
     */
    Manager.prototype.getLayerById = function (id) {
        for (var i = 0; i < this.layers_.length; i += 1) {
            var layer = this.layers_[i];
            if (layer.getId() === id) {
                return layer;
            }
        }
        return null;
    };
    /**
     * Get layer index
     * @param {string} id Id
     * @return {number}
     */
    Manager.prototype.getLayerIndex = function (id) {
        var index = -1;
        for (var i = 0; i < this.layers_.length; i += 1) {
            var layer = this.layers_[i];
            if (layer.getId() === id) {
                index = 1;
                break;
            }
        }
        return index;
    };
    /**
     * Add layer
     * @param {import("./Base").LayerLike} layer Layer
     */
    Manager.prototype.addLayer = function (layer) {
        if (layer instanceof BaseLayer) {
            layer.setMap(this.cercaliaMap_);
            layer.initialize();
        }
        else {
            layer.setMap(this.cercaliaMap_);
        }
        this.layers_.push(layer);
    };
    /**
     * @param {import("./Base").LayerLike} layer Remove layer
     */
    Manager.prototype.removeLayer = function (layer) {
        for (var i = 0; i < this.layers_.length; i += 1) {
            if (this.layers_[i] === layer) {
                if (layer instanceof BaseLayer) {
                    layer.clear();
                    layer.removeLayers();
                }
                else {
                    layer.setMap(null);
                }
                this.layers_.splice(i, 1);
                return;
            }
        }
        console.warn('Layer doesn\'t exist in map'); // eslint-disable-line no-console
    };
    /**
     * @param {string} id Id
     */
    Manager.prototype.removeLayerById = function (id) {
        var index = this.getLayerIndex(id);
        if (index !== -1) {
            this.layers_.splice(index, 1);
        }
        else {
            console.warn("Layer ".concat(id, " not found")); // eslint-disable-line no-console
        }
    };
    /**
     * @return {Array.<string>}
     */
    Manager.prototype.getFeaturesLayersIds = function () {
        var layersId = [];
        this.layers_.forEach(function (layer) {
            if (layer instanceof BaseLayer) {
                layersId = layersId.concat(layer.getLayersId());
            }
        });
        return layersId;
    };
    /**
     * @return {Array.<import("./Base").LayerLike>}
     */
    Manager.prototype.getLayers = function () {
        return this.layers_;
    };
    /**
     * Detach layers from map
     */
    Manager.prototype.detachLayers = function () {
        this.layers_.forEach(function (layer) {
            if (layer instanceof BaseLayer) {
                layer.removeLayers();
            }
            else {
                layer.setMap(null);
            }
        });
    };
    /**
     * Attach layers
     */
    Manager.prototype.attachLayers = function () {
        var _this = this;
        this.layers_.forEach(function (layer) {
            if (layer instanceof BaseLayer) {
                layer.setMap(_this.cercaliaMap_);
                layer.initialize();
            }
            else {
                layer.setMap(_this.cercaliaMap_);
            }
        });
    };
    /**
     * Move layer to a difrent z-position
     * @param {Array.<string>} layerIds Layer Ids
     * @param {string} beforeId Before and existing layer id.
     */
    Manager.prototype.moveLayer = function (layerIds, beforeId) {
        if (this.mapStyler_.getBaseLayerType() === BaseLayerType.VECTOR_TILES) {
            var layerIdsArray = Array.isArray(layerIds) ? layerIds : [layerIds];
            var mbMap_1 = this.cercaliaMap_.getMapboxglMap();
            layerIdsArray.forEach(function (layerId) {
                mbMap_1.moveLayer(layerId, beforeId);
            });
        }
    };
    /**
     * Moves layers to a different z-position
     * @param {Array.<string>} layerIds Layer Ids
     * @param {string} beforeId Before and existing layer id.
     */
    Manager.prototype.moveLayers = function (layerIds, beforeId) {
        var _this = this;
        layerIds.forEach(function (layerId) {
            _this.moveLayer(layerId, beforeId);
        });
    };
    /**
     * @param {boolean} enable Enable
     */
    Manager.prototype.enableBuildings3D = function (enable) {
        var mbMap = this.cercaliaMap_.getMapboxglMap();
        if (mbMap.getLayer(LayersId.BUILDINGS3D)) {
            this.buildings3dEnabled_ = enable;
            mbMap.setLayoutProperty(LayersId.BUILDINGS3D, 'visibility', enable ? 'visible' : 'none');
            mbMap.setLayoutProperty(LayersId.LANDMARKS3D, 'visibility', enable ? 'visible' : 'none');
        }
        else {
            this.buildings3dEnabled_ = false;
        }
    };
    /**
     * @return {boolean}
     */
    Manager.prototype.isBuildings3DEnabled = function () {
        return this.buildings3dEnabled_;
    };
    return Manager;
}());
export default Manager;
//# sourceMappingURL=Manager.js.map